import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function GoogleCallback() {
  const nav = useNavigate();
  const ran = useRef(false);
  const [msg, setMsg] = useState('Finishing Google sign-in…');
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const p = new URLSearchParams(window.location.search);
    if (p.get('error')) { toast.error(`Google sign-in cancelled (${p.get('error')})`); nav('/admin/google', { replace: true }); return; }
    axios.post(`${API_URL}/api/admin/google/exchange`, { code: p.get('code'), state: p.get('state') }, { withCredentials: true })
      .then(({ data }) => { toast.success(`Google reconnected as ${data.email}`, { description: 'Sheet exports are working again.' }); nav('/admin/google', { replace: true }); })
      .catch((e) => { setMsg('Reconnect failed'); toast.error(e.response?.data?.detail || 'Could not reconnect Google', { duration: 10000 }); nav('/admin/google', { replace: true }); });
  }, [nav]);
  return <div className="min-h-screen flex items-center justify-center gap-2 text-sm text-[#6B6B6B]" data-testid="google-callback"><Loader2 className="animate-spin text-[#FF451A]" size={16} /> {msg}</div>;
}
